import { Pill } from '@mantine/core';
import { clsx } from 'clsx';

import classes from './tag-theme.module.css';
import { shouldUseWhiteText } from '../../utils/color';

import type { TagSystemProps } from './tag-types';

export const TagSystem = (props: TagSystemProps) => {
  const { color, children, size = 'standard', className, 'data-testid': dataTestId } = props;

  if (color.startsWith('#')) {
    const textColor = shouldUseWhiteText(color) ? '#ffffff' : '#000000';
    return (
      <Pill
        className={clsx(classes.root, classes.solid, classes[size], className)}
        classNames={{ label: classes.label }}
        data-testid={dataTestId}
        style={{ background: color, '--tag-text-color': textColor } as React.CSSProperties}
      >
        {children}
      </Pill>
    );
  }

  const variant = 'variant' in props ? (props.variant ?? 'solid') : 'solid';
  const shouldShowDot = 'shouldShowDot' in props ? (props.shouldShowDot ?? true) : true;
  const isOutline = variant === 'outline';

  return (
    <Pill
      className={clsx(classes.root, classes[color], classes[variant], classes[size], className)}
      classNames={{ label: classes.label }}
      data-testid={dataTestId}
    >
      {isOutline && shouldShowDot && <span className={classes.dot} />}
      {children}
    </Pill>
  );
};
